<template>
  <div class="sub4">

    <lnb></lnb>

    <!--SECTION-->
    <section class="sec1">
      <img src="img/visual_sub4.png" alt="" class="bg">
    </section>


    <!--SECTION-->
    <section class="sec2">
      <img src="img/pic_txt_lookbook.png" alt="" class="pic">
      <a @click="changeContentsName('Sub2')"><img src="img/btn_shopnow_.png" alt="" class="btn"></a>

      <div id="sub4_slider_btn" class="pic_btn">
        <ul>
          <li><img @click="goToSlider(slider[1], 0)" src="img/pic_lookbook_btn1.png" alt=""></li>
          <li><img @click="goToSlider(slider[1], 1)" src="img/pic_lookbook_btn2.png" alt=""></li>
          <li><img @click="goToSlider(slider[1], 2)" src="img/pic_lookbook_btn3.png" alt=""></li>
        </ul>
      </div>

      <a><img @click="prevSlider(slider[2])" src="img/btn_left.png" alt="" class="left"></a>
      <a><img @click="nextSlider(slider[2])" src="img/btn_right.png" alt="" class="right"></a>

      <div id="sub4_slider1">
        <ul>
          <li><img src="img/lookbook_01.png" alt=""></li>
          <li><img src="img/lookbook_02.png" alt=""></li>
          <li><img src="img/lookbook_03.png" alt=""></li>
        </ul>
      </div>
    </section>


    <!--SECTION-->
    <section class="sec3">
      <img src="img/pic_cinderella.png" alt="" class="pic">
      <img src="img/txt_cinderella.png" alt="" class="pink_box">
      <a @click="changeContentsName('Sub2')" class="btn"></a>
    </section>

  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Lnb from './Lnb.vue'

  export default {
    name: 'Sub4age',
    components: {
      Lnb
    },
    data () {
      return {
        slider: []
      }
    },
    methods: {
      ...mapMutations([
        'changeContentsName'
      ]),
      pluginBxSlider () {
        const _this = this

        this.slider[1] = $('#sub4_slider1 ul').bxSlider({
          mode: 'fade', // 슬라이드 종류
          speed: 500, // 슬라이드 속도
          slideMargin: 0, // 슬라이드 사이 여백
          pager: false, // 페이지 번호
          pagerSelector: '', // 페이지 번호 선택자
          controls: false, // 이전/다음
          autoControls: false, // 시작/정지
          auto: false, // 자동 슬라이드
          pause: 4000, // 자동 슬라이드 시간
          minSlides: 1, // 최소 슬라이드 갯수
          maxSlides: 1, // 최대 슬라이드 갯수
          moveSlides: 0, // 한번에 움직일 슬라이드의 갯수
          slideWidth: 0, // 슬라이드 가로 너비
          onSliderLoad: function (currentIndex) {
          }, // 슬라이드 준비되면
          onSlideBefore: function ($slideElement, oldIndex, newIndex) {
            _this.slider[2].goToSlide(newIndex)
          }, // 슬라이드 전환 직전
          onSlideAfter: function ($slideElement, oldIndex, newIndex) {
          } // 슬라이드 전환 직후
        })
        this.slider[2] = $('#sub4_slider_btn ul').bxSlider({
          mode: 'horizontal', // 슬라이드 종류
          speed: 500, // 슬라이드 속도
          slideMargin: 13, // 슬라이드 사이 여백
          pager: false, // 페이지 번호
          pagerSelector: '', // 페이지 번호 선택자
          controls: false, // 이전/다음
          autoControls: false, // 시작/정지
          auto: false, // 자동 슬라이드
          pause: 4000, // 자동 슬라이드 시간
          minSlides: 2, // 최소 슬라이드 갯수
          maxSlides: 2, // 최대 슬라이드 갯수
          moveSlides: 1, // 한번에 움직일 슬라이드의 갯수
          slideWidth: 175, // 슬라이드 가로 너비
          onSliderLoad: function (currentIndex) {
          }, // 슬라이드 준비되면
          onSlideBefore: function ($slideElement, oldIndex, newIndex) {
          }, // 슬라이드 전환 직전
          onSlideAfter: function ($slideElement, oldIndex, newIndex) {
          } // 슬라이드 전환 직후
        })
      },
      goToSlider (slider, index) {
        slider.goToSlide(index)
      },
      prevSlider (slider) {
        slider.goToPrevSlide()
      },
      nextSlider (slider) {
        slider.goToNextSlide()
      }
    },
    mounted () {
      setTimeout(() => {
        this.pluginBxSlider()
      }, 200)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sub4Page.vue